/*
 * @Author: 朱亚
 * @Date: 2020-10-10 10:19:09
 * @Last Modified time: 2018-02-06 17:23:56
 * @说明：文件删除接口地址
 */
// 文件删除
export const fileDelete = '/upload/delete'



// WEBPACK FOOTER //
// ./src/api/url/fileUpload.js